import { Checkbox, Input, List, ListItem, Spinner } from '@material-tailwind/react';
import { SearchIcon } from 'lucide-react';
import React, { useState, useEffect, Fragment } from 'react';
import { useGetOffices } from '../../../custom-hooks/use-offices';
import { getOrdinal } from '../../../utils/functions';

const DesiredOfficesTab = ({ formData, handlers }) => {
  const { handleInputChange } = handlers;
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredOffices, setFilteredOffices] = useState([]);

  const { data: offices, isLoading: isOfficesLoading } = useGetOffices();

  const handleOfficeSelection = (officeId) => {
    const updatedSelectedOffices = formData.desiredOffices.some(o => o === officeId)
      ? formData.desiredOffices.filter(o => o !== officeId)
      : [...formData.desiredOffices, officeId];
    handleInputChange({ target: { name: 'desiredOffices', value: updatedSelectedOffices } });
  };

  // const handleOfficeDetailChange = (officeId, field, value) => {
  //   const updatedSelectedOffices = formData.desiredOffices.map(o => o.id === officeId ? { ...o, [field]: value } : o);
  //   handleInputChange({ target: { name: 'desiredOffices', value: updatedSelectedOffices } });
  // };

  useEffect(() => {
    if (offices) {
      const filtered = offices.filter(office => office.code.toLowerCase().includes(searchTerm.toLowerCase()));
      setFilteredOffices(filtered);
    }
  }, [offices, searchTerm]);


  return (
    <div>
      <h1>Interested Offices</h1>
      <div className="mt-2">
      <Input
        label="Search Offices"
        placeholder="Search by office code"
        icon={<SearchIcon className="h-4 w-4" />}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      </div>
      <div className="h-[480px] overflow-y-auto">
        <List>
          {
            isOfficesLoading ? (
              <div className="flex justify-center items-center h-full">
                <Spinner />
              </div>
            ) : (
              filteredOffices
                .slice() // Create a copy to avoid mutating the original array
                .sort((a, b) => {
                  const availabilityA = a.availableHours - a.occupiedHours;
                  const availabilityB = b.availableHours - b.occupiedHours;
                  return availabilityB - availabilityA; // Sort by descending availability
                })
                .map((office) => {
                  const availability = office.availableHours - office.occupiedHours;
                  return (
                    <Fragment key={office._id}>
                      <ListItem
                        className="py-1"
                        disabled={availability === 0}
                        selected={formData.desiredOffices.some(o => o === office._id)}
                        onClick={() => handleOfficeSelection(office._id)}>
                        <div className="flex w-full items-center">
                          <Checkbox
                            checked={formData.desiredOffices.some(o => o === office._id)}
                            className="h-4 w-4"
                            ripple={false}
                            readOnly
                          />
                          <div className="flex justify-between items-center w-full">
                            <div className="font-thin">
                              Office # {office.number} ({office.code})
                              <div className={`text-xs`}>
                                <strong>{office.capacity}</strong> Seater | Rate: <strong>{office.monthlyRate}</strong> per month
                              </div>
                            </div>
                            <div className="font-thin text-xs text-gray-600 flex flex-col items-end">
                              <div className={`${availability === 0 ? "text-red-500" : "text-green-500"} `}>
                                {availability === 0 ? "Not Available" : `Available ${availability}h`} <br />
                              </div>
                              <div>
                                On {getOrdinal(office.floor.number)} Floor, In {office.floor.building.name}, Branch {office.floor.building.branch.name}
                              </div>
                            </div>
                          </div>
                        </div>

                      </ListItem>
                      {/* {formData.desiredOffices.some(o => o.id === office._id) && (
                    <div className="ml-8 ">
                      <div className={`flex gap-2 items-center mb-2 flex-col md:flex-row`}>
                        <div className="w-full md:w-1/3">
                          <Input
                            type="number"
                            label="Monthly Rent"
                            placeholder={office.monthlyRate}
                            value={formData.desiredOffices.find(o => o.id === office._id)?.monthlyRent || ''}
                            onChange={(e) => handleOfficeDetailChange(office._id, 'monthlyRent', e.target.value)}
                          />
                        </div>
                        <div className="w-full md:w-2/3 flex items-center gap-2 p-1 px-3 border border-gray-400 rounded-lg font-thin w-full">
                          <div className={`text-xs`}>
                            If the Customer is booking<br />for a specific time slot set
                          </div>
                          <span>Daily Slot From</span>
                          <input
                            type="time"
                            className="focus-visible:outline-none"
                            value={formData.desiredOffices.find(o => o.id === office._id)?.startTime || ''}
                            onChange={(e) => handleOfficeDetailChange(office._id, 'startTime', e.target.value)}
                          />
                          <span>To</span>
                          <input
                            type="time"
                            className="focus-visible:outline-none"
                            value={formData.desiredOffices.find(o => o.id === office._id)?.endTime || ''}
                            onChange={(e) => handleOfficeDetailChange(office._id, 'endTime', e.target.value)}
                          />
                        </div>
                      </div>
                      <div className={`flex gap-2 w-full`}>
                        <Textarea
                          type="text"
                          label="Comments"
                          value={formData.desiredOffices.find(o => o.id === office._id)?.comment || ''}
                          onChange={(e) => handleOfficeDetailChange(office._id, 'comment', e.target.value)}
                        />
                        <div className={`flex flex-col justify-between`}>
                          <div className={``}>
                            <Input
                              type="date"
                              label="Booking From"
                              value={formData.desiredOffices.find(o => o.id === office._id)?.startDate || ''}
                              onChange={(e) => handleOfficeDetailChange(office._id, 'startDate', e.target.value)}
                            />
                          </div>
                          <div className={`mt-2`}>
                            <Input
                              type="date"
                              label="Booking Till"
                              value={formData.desiredOffices.find(o => o.id === office._id)?.endDate || ''}
                              onChange={(e) => handleOfficeDetailChange(office._id, 'endDate', e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )} */}
                    </Fragment>
                  )
                }))
          }
        </List>
      </div>
    </div>
  );
};

export default DesiredOfficesTab;


